module.exports = __webpack_public_path__ + "static/media/full_color_logo.e0f45eef.png";